export default {
      id: "ic_upload-usage",
      viewBox: "0 96 960 960",
      url: __webpack_public_path__ + "img/icons.svg#ic_upload",
      toString: function () {
        return this.url;
      }
    }